import { useContext, useEffect } from 'react';

import ScrollObserverRootContext from '../contexts/ScrollObserverContext/ScrollObserverRootContext';

const useScrollObserverRootContext = () => {
  const context = useContext(ScrollObserverRootContext);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') return;
    if (!context || !context.rootId) {
      console.error('ScrollObserverRootContext is not provided');
    }
  }, [context]);

  return context;
};

export default useScrollObserverRootContext;
